class KinoxTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.live = document.querySelector('.kinox-live-region');
    this.currency = document.documentElement.lang || 'es-UY';
    this.bindOverlays();
    this.bindProductForms();
    this.bindCartChanges();
    this.bindReveals();
    this.bindProductPage();
    this.bindPredictiveSearch();
    this.loadRecommendations();
  }

  bindOverlays() {
    const menu = document.querySelector('[data-mobile-menu]');
    const search = document.querySelector('[data-search-panel]');
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-menu-open]')) this.openOverlay(menu);
      if (event.target.closest('[data-menu-close]')) this.closeOverlay(menu);
      if (event.target.closest('[data-search-open]')) { this.openOverlay(search); setTimeout(() => search?.querySelector('input')?.focus(), 220); }
      if (event.target.closest('[data-search-close]')) this.closeOverlay(search);
      if (event.target.closest('[data-cart-open]')) this.openCart();
      if (event.target.closest('[data-cart-close]')) this.closeOverlay(this.drawer);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      [menu, search, this.drawer].forEach((overlay) => this.closeOverlay(overlay));
    });
  }

  openOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  }

  closeOverlay(overlay) {
    if (!overlay?.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.is-open[data-cart-drawer], .is-open[data-mobile-menu], .is-open[data-search-panel]')) document.body.classList.remove('is-locked');
  }

  bindProductForms() {
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const label = button?.querySelector('span');
      const oldLabel = label?.textContent;
      if (button) button.disabled = true;
      if (label) label.textContent = 'Agregando…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error((await response.json()).description || 'No pudimos agregar el producto.');
        await this.refreshCart();
        this.openCart();
        this.announce('Producto agregado al carrito.');
      } catch (error) {
        this.announce(error.message);
        alert(error.message);
      } finally {
        if (button) button.disabled = false;
        if (label) label.textContent = oldLabel;
      }
    });
  }

  bindCartChanges() {
    document.addEventListener('click', async (event) => {
      const control = event.target.closest('[data-cart-quantity]');
      if (!control) return;
      control.disabled = true;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: control.dataset.lineKey, quantity: Number(control.dataset.cartQuantity) }) });
      await this.refreshCart();
    });
  }

  async openCart() {
    await this.refreshCart();
    this.openOverlay(this.drawer);
    setTimeout(() => this.drawer?.querySelector('[data-cart-close]')?.focus(), 260);
  }

  async refreshCart() {
    const cart = await fetch('/cart.js').then((response) => response.json());
    document.querySelectorAll('[data-cart-bubble]').forEach((node) => { node.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
    const body = this.drawer?.querySelector('[data-cart-body]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>Tu carrito está listo para una KINOX.</p><a class="button button--dark" href="/collections/all">Ver productos</a></div>';
      this.drawer.querySelector('.cart-drawer__footer')?.remove();
      return;
    }
    body.innerHTML = cart.items.map((item) => `<article class="cart-line"><a href="${item.url}"><img src="${item.image || ''}" alt="${this.escape(item.product_title)}" width="120" height="120"></a><div><a class="cart-line__title" href="${item.url}">${this.escape(item.product_title)}</a>${item.variant_title ? `<p>${this.escape(item.variant_title)}</p>` : ''}<p>${this.money(item.final_line_price, cart.currency)}</p><div class="quantity"><button type="button" data-cart-quantity="${item.quantity - 1}" data-line-key="${item.key}" aria-label="Quitar uno">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity + 1}" data-line-key="${item.key}" aria-label="Agregar uno">+</button></div></div></article>`).join('');
    let footer = this.drawer.querySelector('.cart-drawer__footer');
    if (!footer) { footer = document.createElement('footer'); footer.className = 'cart-drawer__footer'; this.drawer.querySelector('.cart-drawer__panel').append(footer); }
    footer.innerHTML = `<div class="cart-total"><span>Subtotal</span><strong>${this.money(cart.total_price, cart.currency)}</strong></div><p>Envío calculado en el checkout.</p><a class="button button--dark button--wide" href="/cart">Ir al checkout</a>`;
  }

  bindReveals() {
    const items = document.querySelectorAll('[data-reveal]');
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { items.forEach((item) => item.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .12 });
    items.forEach((item) => observer.observe(item));
  }

  bindProductPage() {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;
    const form = section.querySelector('.product-form');
    const variants = JSON.parse(section.querySelector('[data-product-json]')?.textContent || '[]');
    const select = section.querySelector('[data-variant-select]');
    form?.addEventListener('change', () => {
      const selected = [...form.querySelectorAll('[data-option-position]:checked')].map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant || !select) return;
      select.value = variant.id;
      const button = form.querySelector('[data-add-button]');
      button.disabled = !variant.available;
      button.querySelector('span').textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    });
    form?.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { const input = form.querySelector('[name="quantity"]'); input.value = Math.max(1, Number(input.value) - 1); });
    form?.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { const input = form.querySelector('[name="quantity"]'); input.value = Number(input.value) + 1; });
    section.querySelector('[data-sticky-submit]')?.addEventListener('click', () => form?.requestSubmit());
    const sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && form && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .1 }).observe(form);
  }

  bindPredictiveSearch() {
    const input = document.querySelector('[data-predictive-search]');
    const results = document.querySelector('[data-predictive-results]');
    let timer;
    input?.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        const data = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`).then((response) => response.json());
        results.innerHTML = data.resources.results.products.map((product) => `<a href="${product.url}"><span>${this.escape(product.title)}</span><strong>${this.money(product.price)}</strong></a>`).join('');
      }, 180);
    });
  }

  loadRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(async (element) => {
      const html = await fetch(element.dataset.url).then((response) => response.text());
      const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
      if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
    });
  }

  money(cents, currency = 'UYU') { return new Intl.NumberFormat(this.currency, { style: 'currency', currency }).format(Number(cents) / 100); }
  escape(value = '') { const node = document.createElement('div'); node.textContent = value; return node.innerHTML; }
  announce(message) { if (this.live) this.live.textContent = message; }
}

document.addEventListener('DOMContentLoaded', () => { window.kinoxTheme = new KinoxTheme(); });
